import { getFunc, singlePostFunc, delFunc } from '@/services/index';

export const loanTypes = () => getFunc('loan-types');
export const loanReasons = () => getFunc('loan-reasons');
export const loanApproval = (status, loan_id) => getFunc(`loans/approve/${status}/${loan_id}`);
export const allLoans = page_number => getFunc(`loans?page=${page_number}`);
export const loanDetails = id => getFunc(`loans/${id}`);
export const loanUpdate = (payload, id) => singlePostFunc(`loans/${id}/update`, payload);
export const disburse = id => getFunc(`loans/disburse/loan/${id}`);
export const redFlag = user_id => getFunc(`loans/flags/${user_id}`);
export const repaymentUpdate = (key,loan_id) => getFunc(`repayment/${key}/${loan_id}`);
export const getLoanByStatus = (status) => getFunc(`loans/status/${status}`);
export const deleteRepayment = id => delFunc(`repayment/${id}`);